import React from 'react'
import { FilterSortProps } from '../types'
import { SORT_OPTIONS } from '../constants'

export const FilterSort: React.FC<FilterSortProps> = ({
  isOpen,
  onToggleFilter,
  sortOrder,
  onSortChange,
}) => {
  return (
    <div className="flex items-center gap-4 w-full justify-between py-4">
      <button
        className="flex items-center gap-1 text-sm"
        onClick={onToggleFilter}
      >
        <span className="hover:underline">Filter</span>
        <span>{isOpen ? '-' : '+'}</span>
      </button>
      <div className="flex items-center gap-2 text-xs">
        <span>Sort by:</span>
        <select
          value={sortOrder}
          onChange={(e) => onSortChange(e.target.value)}
          className="text-xs bg-transparent focus:outline-none cursor-pointer"
          aria-label="Sort order"
        >
          {SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
